module.exports = __webpack_public_path__ + "static/media/cooking-yellow.00d88444.png";